'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../selectors/ConfigSelectors';
import { talkToSalesTypeSelector } from '../../selectors/PurchaseMotionSelectors';
import PurchaseMotionButtonWrapper from '../auth-cta-motions/PurchaseMotionButtonWrapper';
import TalkToSalesButton from '../public-only/TalkToSalesButton';
import { getFirstHubSkuIdFromProductConfigurations } from '../../selectors/ProductConfigsSelectors';

const BannerTalkToSalesButton = ({
  productConfigurations,
  upgradeData
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const firstHubSkuId = useSelector(state => getFirstHubSkuIdFromProductConfigurations(state, {
    productConfigurations
  }));
  const ttsPurchaseMotion = useSelector(state => talkToSalesTypeSelector(state));

  if (!isAppAuth) {
    return /*#__PURE__*/_jsx(TalkToSalesButton, {
      skuId: firstHubSkuId,
      sourceId: "banner",
      use: "tertiary",
      size: "xs"
    });
  }

  return /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
    use: "tertiary",
    size: "xs",
    level: 1,
    purchaseMotions: [ttsPurchaseMotion],
    productConfigurations: productConfigurations,
    upgradeData: upgradeData,
    trackingSource: "banner"
  });
};

export default BannerTalkToSalesButton;